import _ from 'lodash'
import { priceSortField } from '../../features/table/sortSlice'
import { ASC_SORT_ORDER } from '../constants/sortOrders'

const sortFlatParts = (flatParts, sort) => {
    const iteratees = [sort.sortBy]
    const orders = [sort.sortOrder.toLowerCase()]

    if (sort.sortBy === priceSortField) {
        // Parts with zero price always in the end
        iteratees.unshift((part) => part[priceSortField] <= 0)
        orders.unshift(ASC_SORT_ORDER.toLowerCase())
    }

    return _.orderBy(flatParts, iteratees, orders)
}

export default sortFlatParts
